<template>
  <b-modal
    title="Update User"
    ref="update-user-modal"
    id="update-user-modal"
    size="lg"
    ok-title="Update"
    @ok="updateUser"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="inviteRule" tag="form">
        <b-form-group label-for="username">
          Email<span class="text-danger">*</span>
          <b-form-input
            id="username"
            v-model="user.username"
            type="email"
            placeholder="test@gmail.com"
            disabled
          />
        </b-form-group>

        <b-form-group label-for="name">
          Name<span class="text-danger">*</span>
          <validation-provider
            #default="{ errors }"
            name="Name"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="user.name"
              :state="errors.length > 0 ? false : null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <validation-provider #default="{ errors }" name="Role" rules="required">
          <div class="d-flex align-items-center mt-3">
            Role <span class="text-danger">*</span>
            <vue-select
              id="role"
              v-model="user.roleId"
              :options="roles"
              :state="errors.length > 0 ? false : null"
              :reduce="(option) => option.id"
              label="name"
              class="half-width float-left ml-1"
            />
          </div>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import UserService from "@/services/user.service";
import CommonService from "@/services/common.service";

export default {
  name: "UpdateUserModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    updatingUser: {
      type: Object,
      default: {},
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: [],

      user: {},
      required,
    };
  },
  watch: {
    updatingUser(newVal) {
      this.user = {
        id: newVal.id,
        name: newVal.name,
        roleId: newVal.role.id,
        username: newVal.username,
      };
    },
  },
  methods: {
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.inviteRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async updateUser(e) {
      e.preventDefault();
      await this.checkInfo();

      this.$swal({
        title: "Are you sure?",
        html: `You want to update the user!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await UserService.update(this.user);
          if (response && response.status === 200) {
            this.user = {};
            this.$bvModal.hide("update-user-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully updated!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
    async loadRoles() {
      const response = await CommonService.getRoles();
      if (response && response.data.success) {
        this.roles = response.data.data;
      }
    },
  },
  created() {
    this.loadRoles();
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>